<template>
    <div class="picker">
        <div class="picker-value" @click="showModal">
            <slot></slot>
            <div class="font-icon-arrow-right iconfont">&#xe69a;</div>
        </div>
        <div class="picker-modal" v-show="show">
            <div class="picker-modal-back" @click="hideModal" v-show="ms"></div>
            <div class="picker-modal-ctx" :class="{show: ms}">
                <div class="picker-modal-close" @click="hideModal"></div>
                <h3 class="picker-modal-title">{{title}}</h3>
                <div class="picker-modal-columns" v-if="show">
                    <div class="picker-columns-area" v-if="type == 'selector'">
                        <picker-column class="picker-column-item" :range="range" :index.sync="index"></picker-column>
                    </div>
                    <div class="picker-columns-area" v-else-if="type == 'multiSelector'">
                        <picker-column class="picker-column-item" :index.sync="index[i]" :range="r" v-for="(r, i) in range" :key="i"></picker-column>
                    </div>
                </div>
                <div class="picker-confirm" @click="confirm">确定</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "picker",
        model: {
            event: 'change'
        },
        props: {
            title: String,
            range: {
                type: Array,
                default() {
                    return []
                }
            },
            placeholder: String,
            value: [String, Array],
            type: {
                type: String,
                default: 'selector'
            }
        },
        data() {
            return {
                index: null,
                show: false,
                ms: false,
            }
        },
        created() {
            this.setIndex();
        },
        methods: {
            setIndex() {
                let type = this.type, value = this.value, range = this.range;
                if(type == 'selector') {
                    let i = range.indexOf(value);
                    if(i >= 0) {
                        this.index = i;
                    }
                } else if(type == 'multiSelector') {
                    let len = range.length;
                    let index = Array(len).fill(0);
                    if(Array.isArray(value)) {
                        range.forEach((item, i) => {
                            if(value[i]) {
                                let j = item.indexOf(value[i]);
                                if(j >= 0) {
                                    index[i] = j;
                                }
                            }
                        })
                    }
                    this.index = index;
                }
            },
            hideModal() {
                this.ms = false;
                setTimeout(() => {
                    this.show = false;
                }, 300);
            },
            showModal() {
                this.setIndex();
                this.show = true;
                this.$nextTick(() => {
                    this.ms = true;
                })
            },
            confirm() {
                let index = this.index, range = this.range, type = this.type;
                let value = null;
                if(type == 'selector') {
                    value = range[index];
                } else if(type == 'multiSelector') {
                    value = [];
                    range.forEach((item, i) => {
                        value.push(item[index[i]]);
                    });
                }
                if(value !== null) {
                    this.$emit("change", value);
                }
                this.hideModal();
            }
        }
    }
</script>

<style lang="less">
    .picker-value {
        display: flex;
        align-items: center;
        position: relative;
        padding: 0 60px 0 20px;
        height: 60px;
        border: var(--border);
        border-radius: 4px;
        background-color: var(--back-white-color);
        .font-icon-arrow-right {
            position: absolute;
            top: 0;
            bottom: 0;
            right: 12px;
            margin: auto 0;
            width: 28px;
            height: 28px;
            font-size: 28px;
            line-height: 28px;
            color: var(--tip-font-color);
        }
    }
    .picker-modal {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
    }
    .picker-modal-back {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: var(--back-modal-color);
    }
    .picker-modal-ctx {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 0 24px;
        border-top-left-radius: 24px;
        border-top-right-radius: 24px;
        background-color: var(--back-white-color);
        transform: translateY(100%);
        transition: transform .3s;
        &.show {
            transform: translateY(0);
        }
    }
    .picker-modal-close {
        position: absolute;
        top: 40px;
        left: 50px;
        width: 36px;
        height: 36px;
        transform: rotate(45deg);
        &::before,
        &::after {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: var(--title-font-color);
        }
        &::before {
            margin: auto 0;
            height: 1px;
        }
        &::after {
            margin: 0 auto;
            width: 1px;
        }
    }
    .picker-modal-title {
        padding: 40px 0;
        text-align: center;
    }
    .picker-modal-columns {
        height: 480px;
    }
    .picker-columns-area {
        display: flex;
        height: 480px;
    }
    .picker-column-item {
        flex: 1;
    }
    .picker-confirm {
        margin: 40px auto 80px;
        padding: 16px 48px;
        width: 368px;
        border-radius: 8px;
        background-color: var(--main-color);
        font-weight: 700;
        font-size: 32px;
        text-align: center;
        color: #fff;
        line-height: 1.41176471;
    }
</style>
